import React from 'react';
import { ChevronDown, ChevronUp, ChevronsUp, Equal } from 'lucide-react';
import { Priority } from '@/api/mastersApi';

interface PriorityIconProps {
  priority?: Partial<Priority> | null;
  className?: string;
  size?: number;
}

/**
 * PriorityIcon component - JIRA-style priority icon with color
 * Shows appropriate icon based on priority level
 */
export const PriorityIcon: React.FC<PriorityIconProps> = ({ 
  priority, 
  className = '', 
  size = 16 
}) => {
  if (!priority) {
    return null;
  }

  // Determine icon and color based on priority key
  const getPriorityIconAndColor = (key?: string, name?: string) => {
    const keyOrName = (key || name || '').toLowerCase();
    
    if (keyOrName === 'critical' || keyOrName.includes('critical')) {
      return {
        Icon: ChevronsUp,
        color: 'text-red-600'
      };
    } else if (keyOrName === 'high' || keyOrName.includes('high')) {
      return {
        Icon: ChevronUp,
        color: 'text-red-600'
      };
    } else if (keyOrName === 'medium' || keyOrName.includes('medium')) {
      return {
        Icon: Equal,
        color: 'text-orange-600'
      };
    } else if (keyOrName === 'low' || keyOrName.includes('low')) {
      return {
        Icon: ChevronDown,
        color: 'text-blue-600'
      };
    }
    
    // Default fallback
    return {
      Icon: Equal,
      color: 'text-gray-600'
    };
  };

  const { Icon, color } = getPriorityIconAndColor(priority.key, priority.name);
  const colorClass = color;

  return (
    <Icon 
      className={`${colorClass} ${className}`} 
      size={size}
      strokeWidth={2}
    />
  );
};

